export enum LayoutViewType {
  SC3_LAYOUT = 1, // SC3
  SAMA_RED_LAYOUT = 2, // SAMA RED
  NGINR_LAYOUT = 3, // NGINR
  SAMA_BLACK_LAYOUT = 4, // SAMA BLACK
  FULL = 5,
}

export enum UserGuideTab {
  'system-login' = 'system-login',
  'sc3' = 'sc3',
  'nginr' = 'nginr',
  'hymots-g' = 'hymots-g',
  'etecube' = 'etecube',
}

export enum SystemType {
  RED = 'Red',
  BLACK = 'Black',
}

export enum AuthenticationEnum {
  DISABLED = 0,
  PALMREADERAUTHENTICATION = 1,
}

export enum ResetPasswordStatus {
  Active = 0,
  Inactive = 1,
}

export enum LicenseEnum {
  ETECUBE = 'a91abb36-fd1e-4821-8fb2-0d69bfb2eba0',
  HYMOTSG = '4617a008-3254-47c2-8d8c-60df36d4f3c2',
}
